import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "img-container d-flex ion-justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_ctx.item)
    ? (_openBlock(), _createBlock(_component_ion_card, {
        key: 0,
        class: "ion-text-center color-dark"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.backText && !_ctx.isNative)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "full-width ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button, {
                    "aria-label": "back",
                    mode: "md",
                    backText: _ctx.backText,
                    class: "back-btn"
                  }, null, 8, ["backText"]),
                  _createVNode(_component_ion_item_divider, { class: "mx-16" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h1", {
            innerHTML: _ctx.editing ? _ctx.displayName : _ctx.item.name,
            class: _normalizeClass(["mt-8 bold menu-item-title", { editing: _ctx.editing }]),
            "data-cy": "menu-item-title"
          }, null, 10, _hoisted_1),
          _createVNode(_component_ion_row, { class: "full-width d-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ion_img, {
                  src: _ctx.isMobile ? _ctx.item.mobileImg : _ctx.item.cdnImg,
                  class: _normalizeClass(_ctx.imageClass),
                  alt: _ctx.displayName,
                  "data-cy": "menu-item-image"
                }, null, 8, ["src", "class", "alt"]),
                (_ctx.item.itemTextBanner)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.item.itemTextBanner), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card_content, {
            class: "interstate-bold item-description",
            innerHTML: _ctx.item.description,
            "data-cy": "menu-item-description"
          }, null, 8, ["innerHTML"])
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}